import { combineReducers } from 'redux';
import defineTypes from 'helpers/defineTypes';

const namespace = 'mt/ui';
const Types = defineTypes(namespace, [
  'CLOSE_NAV_DRAWER',
  'TOGGLE_NAV_DRAWER',
  'TOGGLE_CART_MODAL',
  'TOGGLE_ADD_TO_CART',
]);

// Reducers
const isNavDrawerOpen = (state = false, action) => {
  if (action.type === Types.TOGGLE_NAV_DRAWER) return !state;
  if (action.type === Types.CLOSE_NAV_DRAWER) return false;
  return state;
};

const isCartModalOpen = (state = false, action) => {
  if (action.type === Types.TOGGLE_CART_MODAL) return !state;
  return state;
};

const isAddToCartVisible = (state = false, action) => {
  if (action.type === Types.TOGGLE_ADD_TO_CART) return !state;
  return state;
};

export default combineReducers({
  isNavDrawerOpen,
  isCartModalOpen,
  isAddToCartVisible,
});

// Action Creators
export const closeNavDrawer = () => ({ type: Types.CLOSE_NAV_DRAWER });
export const toggleNavDrawer = () => ({ type: Types.TOGGLE_NAV_DRAWER });
export const toggleCartModal = () => ({ type: Types.TOGGLE_CART_MODAL });
export const toggleAddToCart = () => ({ type: Types.TOGGLE_ADD_TO_CART });



// WEBPACK FOOTER //
// ./src/ducks/ui.js